import React from 'react'
import walkingPizza from 'assets/svg/walking-pizza.svg'
import walkingWatermelon from 'assets/svg/walking-watermelon.svg'
import walkingFries from 'assets/svg/walking-fries.svg'
import LazyImage from 'app/theme/LazyImage'

export default function BookTruckBar(props) {
  const { url, className, ...rest } = props;

  return(
    <a
      href={url}
      {...rest}
      className={[
        className,
        'block w-full bg-blue px-4 sm:px-6 py-5 sm:flex flex-row sm:py-2 sm:items-center sm:justify-between'
      ]}
    >
      <div
        className={[
          'flex items-center justify-center mb-2',
          'sm:order-2 sm:mb-0 sm:text-right sm:justify-end'
        ]}
      >
        <LazyImage
          src={walkingPizza}
          width="34"
          alt="Pizza"
        />
        <LazyImage
          src={walkingWatermelon}
          width="50"
          alt="Watermelon"
        />
        <LazyImage
          src={walkingFries}
          width="40"
          className="ml-2"
          alt="Fries"
        />
      </div>
      <p className="sm:order-1 font-light text-center leading-none text-white text-2xl xl:text-3xl">
        We’ll book a food truck for your next event
      </p>
    </a>
  )
}
